<template>
    <el-input :placeholder="placeholder" v-model="searchKey" :class="['input-with-select',$style['search-input']]" :clearable="true" @mousedown.stop.native @click.stop.native @keydown.enter.native="handleSearch(searchKey)">
        <el-button slot="append" :icon="icon" @click="handleSearch(searchKey)"></el-button>
    </el-input>
</template>

<script>
export default {
  props: {
    targetStatus: {
      type: String,
      required: true
    },
    isUseTableSpi: {
      type: Boolean,
      default: false
    },
    extraParams: {
      type: Object,
      default: () => {}
    },
    placeholder: {
      type: String,
      default: '请输入条码号'
    }
  },
  data () {
    return {
      searchKey: '',
      loading: false
    }
  },
  computed: {
    icon () {
      return this.loading ? 'el-icon-loading' : 'el-icon-search'
    },
    bulidParams () {
      let defaultParams = {
        'targetStatus': this.targetStatus,
        'fuzzyQuery': this.searchKey || null,
        'pageableParam': {}
      }
      if (JSON.stringify(this.extraParams) !== '{}') {
        for (let key in this.extraParams) {
          if (!defaultParams.hasOwnProperty[key]) {
            defaultParams[key] = this.extraParams[key]
          }
        }
      }
      return defaultParams
    }
  },
  methods: {
    handleSearch (key) {
      // 勾选时允许关键字为空此时搜索全部订单，扫描时必须检查关键字不为空
      if (this.isUseTableSpi) {
        this.$emit('searchFun', this.bulidParams)
        return
      } else {
        if (!this.searchKey) {
          this.$message.error('请输入样本号')
          return
        }
      }
      this.loading = true
      let defaultParams = {
        needActionTaskInfo: true,
        pageableParam: { page: 0, size: 999999 }
      }
      for (let key in this.bulidParams) {
        if (!defaultParams.hasOwnProperty[key]) {
          defaultParams[key] = this.bulidParams[key]
        }
      }
      let api = this.$route.query.isAdult ? 'adultOrderFuzzy' : 'labOrderFuzzy'
      this.$store.dispatch(api, defaultParams).then(res => {
        this.loading = false
        this.$emit('getSearchData', res.data)
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '搜索失败')
      })
    }
  }
}
</script>

<style module lang="less">
.search-input{
    width:280px;
}
</style>
